export function getUrlByMediaId (mediaId: string) {
  return `/yi/media/${mediaId}`
}
